import styled from 'styled-components';
import { P, onPhone } from '../theme/tokens';

const Header = styled.div`
  margin-bottom: 20px;
  h1 {
    margin: 0 0 4px;
    font-size: 20px;
    font-weight: 600;
    color: ${P.ink};
  }
  p {
    margin: 0;
    font-size: 14px;
    color: ${P.muted};
  }
  ${onPhone} {
    margin-bottom: 12px;
    h1 {
      margin: 0;
      font-weight: 700;
    }
    p {
      display: none;
    }
  }
`;

export default function PageHeader({ title, subtitle, style }) {
  return (
    <Header style={style}>
      <h1>{title}</h1>
      {subtitle ? <p>{subtitle}</p> : null}
    </Header>
  );
}
